/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateRemediationResponse {
    getFixupPrototypeFunction() { return CreateRemediationResponse.fixupPrototype; }

    static newInstance(model: Partial<CreateRemediationResponse>): CreateRemediationResponse {
        let obj = Object.assign(new CreateRemediationResponse(), model);
        CreateRemediationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateRemediationResponse>): CreateRemediationResponse {
        if (!model) return null;
        return CreateRemediationResponse.newInstance(<CreateRemediationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateRemediationResponse) {
        if (!obj) return;

        models.CreateRemediationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateRemediationResponse): boolean {
        Object.setPrototypeOf(obj, CreateRemediationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tag Remediation ID
     */
    resource_enforce_tag_id: string;

}
